import { sanitizeColorForDataAttr } from '../components/tools/chipColorDataAttr';
import { setCspSafeStyleBlock } from './cspSafeStyles';

export const RANK_CHIP_CSP_STYLE_ID = 'rank-chip-csp-colors';

/** @type {Map<string, Set<string>>} */
const registry = new Map();

function escapeAttrSelectorValue(value) {
  return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

/**
 * @param {string} color — sanitized #hex / rgb() / rgba()
 * @returns {string}
 */
export function buildRankChipColorCssRules(color) {
  const esc = escapeAttrSelectorValue(color);
  const sel = `[data-chip-bg="${esc}"]`;

  return `
.user-chip.user-chip--rank-tinted${sel}{
  border-color:${color};
  background:transparent;
}
.user-chip.user-chip--rank-tinted${sel}::after{
  background-color:${color};
}
.user-tooltip.user-tooltip--rank-tinted${sel}{
  border-color:color-mix(in srgb,${color} 50%,transparent);
}
.user-tooltip.user-tooltip--rank-tinted${sel}::before{
  border-bottom-color:color-mix(in srgb,${color} 50%,transparent);
}
.user-discord-rank.user-discord-rank--profile-chip${sel}::after{
  background-color:${color};
}
.user-discord-rank.user-discord-rank--profile-chip${sel}:hover,
.user-discord-rank.user-discord-rank--profile-chip${sel}.user-discord-rank--profile-chip-open{
  border-color:${color};
}
.member-dashboard__rank-timeline-rank--rank-tinted${sel}{
  border-color:${color};
  background:transparent;
}
.member-dashboard__rank-timeline-rank--rank-tinted${sel}::after{
  background-color:${color};
}`.trim();
}

function flushRankChipCspStyles() {
  const all = new Set();
  for (const colors of registry.values()) {
    for (const color of colors) all.add(color);
  }
  const css = [...all].map(buildRankChipColorCssRules).join('\n');
  setCspSafeStyleBlock(RANK_CHIP_CSP_STYLE_ID, css);
}

/**
 * @param {string} subscriberId
 * @param {Iterable<string|null|undefined>} colors
 */
export function registerRankChipColors(subscriberId, colors) {
  const set = new Set();
  for (const raw of colors) {
    const sanitized = sanitizeColorForDataAttr(raw);
    if (sanitized) set.add(sanitized);
  }
  if (set.size === 0) {
    registry.delete(subscriberId);
  } else {
    registry.set(subscriberId, set);
  }
  flushRankChipCspStyles();
}

/** @param {string} subscriberId */
export function unregisterRankChipColors(subscriberId) {
  if (!registry.has(subscriberId)) return;
  registry.delete(subscriberId);
  flushRankChipCspStyles();
}

/** @param {null|{ chipColor?: string|null, text?: string|null }|undefined} rankColors */
export function rankChipBgFromRankColors(rankColors) {
  return sanitizeColorForDataAttr(rankColors?.chipColor);
}
